import { Card } from 'antd'
import styled from 'styled-components'

export const StyledCard = styled(Card)`
  background-color: ${({ theme }) => theme.colors.grayscale[600]};
  .ant-card-head {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grayscale[500]};
  }

  @media print {
    break-inside: avoid;
    overflow: visible;
  }
`
